module.exports = __webpack_public_path__ + "static/media/eyewearstore-faviconfav.79361e96.ico";